import Vue from 'vue';
import Router from 'vue-router';
import { MeAPIService } from '@/servicehandlers/MeAPIService';
import { store } from './store';
import About from '@/views/About';
import BindAuthorityProduction from '@/components/reports/BindAuthorityProduction';
import Bordereaux from '@/components/reports/Bordereaux';
import ClaimsSearch from '@/components/search/claims/ClaimsSearch';
import ContactsSearch from '@/components/search/contacts/ContactsSearch';
import CommissionsManager from '@/components/management/CommissionsManager';
import EditClaim from '@/components/search/claims/EditClaim';
import EditContact from '@/components/search/contacts/EditContact';
import EditFirm from '@/components/search/firms/EditFirm';
import EditNoteEmail from '@/components/search/firms/EditNoteEmail';
import EditPerson from '@/components/search/firms/EditPerson';
import EditPolicy from '@/components/search/firms/EditPolicy';
import FirmsSearch from '@/components/search/firms/FirmsSearch';
import Home from '@/views/Home.vue';
import IdlePage from '@/components/idle/IdlePage';
import LedgersSearch from '@/components/search/ledgers/LedgersSearch';
import Login from '@/components/Login';
import LossRun from '@/components/reports/LossRun';
import Manager from '@/components/management/Manager';
import MgaBillingManager from '@/components/management/MgaBillingManager';
import PeopleSearch from '@/components/search/people/PeopleSearch';
import ProducerCommissionsManager from '@/components/management/ProducerCommissionsManager';
import Renewal from '@/components/reports/Renewal';
import ReportsSearch from '@/components/reports/ReportsSearch';
import Roles from '@/components/rights/Roles';
import TaxManager from '@/components/management/TaxManager';
import ViewClaim from '@/components/search/claims/ViewClaim';
import ViewFirm from '@/components/search/firms/ViewFirm';
import ViewFirmNoNote from '@/components/search/firms/ViewFirmNoNote';
import ViewPolicy from '@/components/search/firms/ViewPolicy';

Vue.use(Router);
let testRoutes = [];
if (process.env.VUE_APP_FEATURES !== 'production') {// these are the routes that are NOT ready for production, but are included for development and testing
  testRoutes = [
  {
    path: '/about',
    name: 'About',
    component: About,
  },
];
}

// remove the links if the user does not have rights to see them
export const router = new Router({// ready for beta/production
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: { name: 'Home' },
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        public: true
      }
    },
    {
      path: '/idle',
      name: 'Idle',
      component: IdlePage
    },
    {
      path: '/reports/bindauthority',
      name: 'BindAuthorityProduction',
      component: BindAuthorityProduction,
      meta: {
        scopes: ['bindauthority-view']
      }
    },
    {
      path: '/reports/bordereau',
      name: 'Bordereaux',
      component: Bordereaux,
      meta: {
        scopes: ['bordereau-view']
      }
    },
    {
      path: '/reports/reportsSearch',
      name: 'ReportsSearch',
      component: ReportsSearch,
      meta: {
        scopes: ['report-view']
      }
    },
    {
      path: '/search/contacts/contactsSearch',
      name: 'ContactsSearch',
      component: ContactsSearch,
      meta: {
        scopes: ['contact-view']
      }
    },
    {
      path: '/editContact/:id',
      name: 'editContact',
      component: EditContact,
      meta: {// also used for viewing contact information, so contact-view will allow navigating to component
        // after navigating to EditContact scope 'contact-edit' is required in the component to edit
        scopes: {
          any: true,
          scopes: ['contact-view', 'contact-edit'] // User only needs one of these
        }
      },
      props: true
    },
    {
      path: '/search/claims/claimsSearch',
      name: 'ClaimsSearch',
      component: ClaimsSearch,
      meta: {
        scopes: ['claim-view']
      }
    },
    {
      path: '/search/ledgers/ledgersSearch',
      name: 'LedgersSearch',
      component: LedgersSearch,
      meta: {
        scopes: ['ledger-view']
      }
    },
    {
      path: '/reports/Renewal',
      name: 'Renewal',
      component: Renewal,
      meta: {
        scopes: ['claim-view']
      },
    },
    {
      path: '/reports/LossRun',
      name: 'LossRun',
      component: LossRun,
      meta: {
        scopes: ['claim-view']
      },
    },
    {
      path: '/search/claims/editClaim',
      name: 'EditClaim',
      component: EditClaim,
    },
    {
      path: '/search/people/peopleSearch',
      name: 'PeopleSearch',
      component: PeopleSearch,
      meta: {
        scopes: ['person-view'],
      },
    },
    {
      path: '/editPerson/:id',
      name: 'editPerson',
      component: EditPerson,
      // need 'contact-view' or 'person-view' to nav to EditPerson to view/edit contacts, members or people (they are all people)
      // after navigating to EditPerson, an additional scope 'person-edit' is required within the component to edit
      meta: {
        scopes: {
          any: true,
          // only need one of these because it can be reached by way of Firms and (contact & person are both people)
          scopes: ['contact-view', 'person-view', 'firm-view']
        }
      },
      props: true
    },
    {
      path: '/editClaim/:id',
      name: 'editClaim',
      component: EditClaim,
      meta: {
        scopes: ['claim-edit']
      },
      props: true
    },
    {
      path: '/viewClaim/:id',
      name: 'viewClaim',
      component: ViewClaim,
      meta: {
        scopes: ['claim-view']// consistent with scope requirements in claimsSearch and FirmClaimsTable
      },
      props: true
    },
    {
      path: '/editPolicy/:id',
      name: 'editPolicy',
      component: EditPolicy,
      meta: {
        scopes: ['policy-edit']
      },
      props: true
    },
    {
      path: '/ViewPolicy/:id',
      name: 'ViewPolicy',
      component: ViewPolicy,
      meta: {
        scopes: {
          any: true,
          scopes: ['policy-view', 'firm-view'] // user only needs one of these because it can be reached by way of Firms
        }
      },
      props: true
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
    },
    {
      path: '/editFirm/:id',
      name: 'editFirm',
      component: EditFirm,
      meta: {
        scopes: ['firm-edit']
      },
      props: true
    },
    {
      path: '/search/firms/firmsSearch',
      name: 'FirmsSearch',
      component: FirmsSearch,
      meta: {
        scopes: ['firm-view'],
      }
    },
    {//this component wraps ViewFirm and sets noNote to true
      path: '/viewFirmNoNote/:id',
      name: 'viewFirmNoNote',
      component: ViewFirmNoNote,
      meta: {
        scopes: ['firm-view'],
      },
      props: true,
    },
    {//this component wraps ViewFirm, sets noNote to true, and sets tablesProp to the desired firm table (ex: 'Members')
      path: '/viewFirmNoNote/:id/:tablesProp',
      name: 'viewFirmNoNote',
      component: ViewFirmNoNote,
      props: true,
    },
    {
      path: '/viewFirmNote/:id',
      name: 'view',
      component: ViewFirm,
      meta: {
        scopes: ['firm-view'],
      },
      props: true,
    },
    {
      path: '/search/firms/viewFirm',
      name: 'ViewFirm',
      component: ViewFirm,
      meta: {
        scopes: ['firm-view'],
      },
    },
    {
      path: '/editNoteEmail/:id',
      name: 'editNoteEmail',
      component: EditNoteEmail,
      meta: {
        scopes: ['firm-view'],
      },
      props: true
    },
    {
      path: '/manage',
      name: 'Manager',
      component: Manager,
      children: [
        {
          path: 'commissions',
          name: 'CommissionsManager',
          component: CommissionsManager,
          meta: {
            scopes: ['mgacommission-manage']
          }
        },
        {
          path: 'mgaBilling',
          name: 'MgaBillingManager',
          component: MgaBillingManager,
          meta: {
            scopes: ['mgabilling-manage']
          }
        },
        {
          path: 'producerCommissions',
          name: 'ProducerCommissionsManager',
          component: ProducerCommissionsManager,
          meta: {
            scopes: ['producercommission-manage']
          }
        },
        {
          path: 'roles',
          name: 'Roles',
          component: Roles,
          meta: {
            scopes: ['role-edit']
          }
        },
        {
          path: 'taxes',
          name: 'TaxManager',
          component: TaxManager,
          meta: {
            scopes: ['tax-manage']
          }
        },
      ]
    },
    ...testRoutes
  ],
});

const meAPIService = new MeAPIService();
router.beforeEach(async (to, from, next) => {
  if (store.state.timedOut) {// Block navigation entirely if idle dialog is active
    console.debug('📍 Navigation blocked: user is idle and must relogin.');
    return next(false); // Cancel navigation
  }
  await Vue.nextTick(); // Wait until Vue app is fully mounted
  const loggedIn = store.state.loggedIn;// Always check login state explicitly

  if (loggedIn === null || loggedIn === false) {// Allow recheck session if loggedIn is null OR false (eg new tab load)
    // If not logged in yet, try to get user data.
    // (User may have a session, but store may not be initialized.)
    try {
      await meAPIService.getUserData(router);
    } catch (error) {
      console.debug('🔕 Router caught 401 from getUserData:', error); // Suppress dev overlay (already handled/logged)
      const isPublic = to.matched.some(({ meta }) => meta.public);
      if (isPublic) return next();
      if (to.path === '/login') return next();
      return next({ path: '/login' });
    }
  }

  if (store.state.loggedIn !== true) { // Handle confirmed logged-out state after recheck
    const isPublic = to.matched.some(({ meta }) => meta.public);
    if (isPublic) return next();
    return next({ path: '/login' });
  }

  const scopesPerRoute = to.matched.map(({ meta }) => meta.scopes);
  const authorized = scopesPerRoute.every(scopes => {
    if (!scopes) return true;
    if (!('scopes' in scopes)) return router.app.$_canAll(scopes); // Scopes is an array
    if (scopes.any) return router.app.$_canAny(scopes.scopes);
    return router.app.$_canAll(scopes.scopes);
  });

  if (authorized) {
    if (to.fullPath === from.fullPath) return; // Avoid duplicate nav
    return next();
  }
  return next('/'); // Fallback if unauthorized
});